@if (toasts().length) {
  <div class="toast-stack" aria-live="polite" aria-atomic="true">
    @for (toast of toasts(); track toast.id) {
      <div
        class="toast-stack__item"
        [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
        (mouseenter)="pause(toast.id)"
        (mouseleave)="resume(toast.id)"
        (focusin)="pause(toast.id)"
        (focusout)="resume(toast.id)"
      >
        <span class="toast-stack__message">{{ toast.message | translate }}</span>
        <button
          type="button"
          class="toast-stack__dismiss"
          (click)="dismiss(toast.id)"
          [attr.aria-label]="'toast.dismiss' | translate"
        >
          ×
        </button>
      </div>
    }
  </div>
}
